// Close the mobile menu after following a link or pressing Escape.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.rv-mobile-menu nav a');
  if (link) link.closest('details').open = false;
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.rv-mobile-menu[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});
